import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { orderBy as orderByLoadash } from 'lodash';
import { i18n } from '../../../translate/i18n';
import { Typography, IconButton, Button, CircularProgress } from '@mui/material';
import { Launch } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import Checklist from '../../../components/Checklist/Checklist';
import * as actions from "../../../store/actions/";
import { FormStyled, DivFormTitle } from '../Forms/styles';
import FileDownloadButton from '../../../components/FileDownloadButton/FileDownloadButton';
import { formatLanguageFromLocalStorage } from '../../../utils/formatLanguageFromLocalStorage';
import { orderQuestionArray } from '../../../utils/orderQuestionArray';

const styles = {
  title: {
    fontWeight: 'bolder',
    textDecoration: 'none',
    color: '#437d6c',
  },
  contentContainer: {
    margin: '0.5rem 0 1rem 0',
  },
  checklistContainer: {
    marginLeft: '0.25rem',
  },
  groupContainer: {
  },
  groupLabel: {
    fontWeight: 'bold',
  },
  questionContainer: {
    marginLeft: '1rem',
  }
}

const ModalEquipmentChecklist = (props) => {
  const dispatch = useDispatch();

  const [groupQuestionArray, setGroupQuestionArray] = useState([]);
  const [exportLoading, setExportLoading] = useState(false);

  const localStorageLang = localStorage.getItem("i18nextLng");
  const emailLanguage = formatLanguageFromLocalStorage(localStorageLang);

  const fetchChecklistExport = () => dispatch(actions.fetchChecklistExport(props.modalContent.equipId, props.modalContent.equipServiceId, emailLanguage));

  const formThreeData = (checklist) => {
    const groupArray = [];

    checklist.forEach(cl => {
      if (cl.type === 'group') {
        cl.questionArray = [];
        groupArray.push(cl)
      }
    });

    const groupArrayOrdered = groupArray.sort(orderQuestionArray);

    checklist.forEach(cl => {
      if (cl.type === 'question') {
        const index = groupArrayOrdered.findIndex(ga => ga._id === cl.groupId._id);
        if (index > -1) {
          groupArrayOrdered[index].questionArray.push(cl)
        }
      }
    });

    setGroupQuestionArray(groupArrayOrdered);
  }

  useEffect(() => {
    formThreeData(props.modalContent.checklist);
  }, []);

  const exportExcel = () => {
    setExportLoading(true);
    fetchChecklistExport()
      .then(response => {
        if (response) {
          window.open(response.url, "_blank")
        }
        setExportLoading(false);
      })
      .catch(() => setExportLoading(false))
  }

  return <>
    <FormStyled>
      <DivFormTitle>
        <Typography
          variant='h6'
          style={styles.title}
        >
          {`CHECKLIST (${props.modalContent ? props.modalContent.inspection : ' '})`}
        </Typography>
        <div style={{ width: '50%', display: 'flex', justifyContent: 'flex-end', alignItems: 'center'}}>
          <Button
              variant='outlined'
              aria-label="add"
              style={{ width: 'fit-content' }}
              onClick={exportExcel}
              disabled={exportLoading}
              startIcon={exportLoading ? <CircularProgress size={14} style={{ color: 'green' }} /> : <Launch style={styles.icon} />}
          >
            {i18n.t('btnTableTileMatOverrides.exportChecklist')}
          </Button>
          <FileDownloadButton
            type="service-checklist"
            title={`${i18n.t('btnTableTileMatOverrides.exportChecklist')} (PDF)`}
            documentId={props.modalContent ? `${props.modalContent.equipServiceId}/${props.modalContent.site}` : ''}
            filters={null}
          />
          <IconButton onClick={props.closeModal} size="large"><CloseIcon /></IconButton>
        </div>
      </DivFormTitle>

      <div style={styles.contentContainer}>
        <Checklist
          data={groupQuestionArray}
          detailsEnabled={false} // To hide the modal with the details
          editionVersion={false} // To hide the create and edit options
        />
        {groupQuestionArray.length === 0 &&
          <div style={{ textAlign: 'center' }}>{i18n.t('divModalEquipCheckList.groupQuestionArray')}</div>}
      </div>

    </FormStyled>
  </>;
}


export default ModalEquipmentChecklist;